
import {
  Component, Mixins,
} from 'vue-property-decorator';
import GetApplicationsOnlyId from '@/graphql/GetApplicationsOnlyId.gql';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';
import { and, like } from '@/classes/pimcore-filtering/Filters';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import { FetchPolicy } from 'apollo-client/core/watchQueryOptions';
import { TypeExtractionRules } from '@/classes/schema-constructors/types';


@Component
export default class LoadingDataMixin extends Mixins(EntityHelperMixin) {
  /**
   * Возвращает массив id ApplicationHR
   * @param filter
   * @return Array
   */
  loadApplicationsIdsByFilter(filter: {$and?: any[]; $or: any[]} | undefined | null): Promise<string[]> {
    let variables = {};
    if (filter) {
      try {
        variables = { filter: JSON.stringify(filter) };
      } catch (e) {
        console.error(e);
      }
    }
    return this.$apollo.query({
      query: GetApplicationsOnlyId,
      variables,
    }).then((res) => {
      if (res?.data?.getApplicationHRListing?.edges?.length) {
        return res?.data?.getApplicationHRListing?.edges.map((item: {node: any}) => item.node.id);
      }
      return [];
    }).catch((e) => {
      console.error(e);
      return [];
    });
  }

  /**
   * Загружает даные по совподению (many to many) и меняет указанное свойство
   * @param variable имя свойства для изменения
   * @param className имя класса в pimcore
   * @param likeKey поле по которому фильтровать
   * @param likeValue значение по которому фильтровать
   * @param fetchPolicy
   * @return Array
   */
  // eslint-disable-next-line max-len
  async loadDataByLike(variable: string, className: string, likeKey: string, likeValue: string | number, fetchPolicy: FetchPolicy = 'network-only', rules?: TypeExtractionRules): Promise<any[]> {
    if (!likeValue) {
      return [];
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this[`${variable}IsLoading`] = true;

    const filterBuilder = new FilterBuilder();
    filterBuilder.addFilters(
      and(
        like(likeKey, `%${likeValue}%`),
      ),
    );

    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this[variable] = await this.loadEntityListing(className, {
        filter: filterBuilder.build(),
      }, fetchPolicy, rules);
    } catch (e) {
      console.error(e);
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this[variable] = [];
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this[`${variable}IsLoading`] = false;
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return this[variable];
  }
}
